import { render } from "./MergeFieldsItem.vue?vue&type=template&id=2da2f475"
import script from "./MergeFieldsItem.vue?vue&type=script&lang=js"
export * from "./MergeFieldsItem.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__